import { useCustomizations } from '@client/new/hooks/use-customizations';

export const useIsGroupedWorkoutSchedulingEnabled = (
  influencerId: number,
): boolean => {
  const { customizations } = useCustomizations(String(influencerId));

  return customizations?.isGroupedWorkoutSchedulingEnabled === true;
};
